var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.025 9.00039C11.025 10.1188 10.1184 11.0254 9 11.0254C7.88162 11.0254 6.975 10.1188 6.975 9.00039C6.975 7.88201 7.88162 6.97539 9 6.97539C10.1184 6.97539 11.025 7.88201 11.025 9.00039Z",
    stroke: "#898E99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.00039C3.33009 6.23467 5.85182 4.27539 9 4.27539C12.1482 4.27539 14.6699 6.23468 15.75 9.00039C14.6699 11.7661 12.1482 13.7254 9 13.7254C5.85182 13.7254 3.33009 11.7661 2.25 9.00039Z",
    stroke: "#898E99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.b2f63fa9c36730618b0ce24319bec68b.svg";
export { ForwardRef as ReactComponent };